import { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { AssignMenuItemCategoryRequestSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const schema = AssignMenuItemCategoryRequestSchema.strict()

const normalize = fieldNormalizer({ int: ['menu_category_id'] })

export const MenuItemAssignCategory = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(normalize, schema)
